import React, { PureComponent } from 'react'

// local components
import ToleranceItem from './ToleranceItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const ToleranceItemEditable = EditableHOCWrapper(ToleranceItem)

class ToleranceItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onToleranceUpdate(data, afterOnSave)
  }

  render() {
    const { tolerance = {}, lastModified = null, defaultEditMode, onDelete, onCancel } = this.props

    return (
      <ToleranceItemEditable
        dataToEdit={tolerance}
        onSave={this.onSave}
        lastModified={lastModified}
        defaultEditMode={defaultEditMode}
        onDelete={onDelete}
        onCancel={onCancel}
      />
    )
  }
}

export default ToleranceItemContainer



// WEBPACK FOOTER //
// ./src/components/WeightTolerance/ToleranceItemContainer.js